import { Controller } from "@hotwired/stimulus"

// Controller for variant form interactions
export default class extends Controller {
  static targets = ["quantity", "unlimitedCheckbox"]

  connect() {
    // Initialize quantity field state based on checkbox
    if (this.hasUnlimitedCheckboxTarget && this.hasQuantityTarget) {
      this.updateQuantityState()
    }
  }

  toggleQuantity() {
    this.updateQuantityState()
  }

  updateQuantityState() {
    if (this.hasQuantityTarget && this.hasUnlimitedCheckboxTarget) {
      const isUnlimited = this.unlimitedCheckboxTarget.checked
      this.quantityTarget.disabled = isUnlimited

      if (isUnlimited) {
        this.quantityTarget.classList.add("bg-gray-100", "text-gray-400")
      } else {
        this.quantityTarget.classList.remove("bg-gray-100", "text-gray-400")
      }
    }
  }
}
